import { ObservableMap } from 'mobx';
import assert from 'owa-assert/lib/assert';
import type { MailboxInfo } from 'owa-client-types';
import type OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import type { SessionUserConfiguration } from 'owa-service/lib/types/SessionUserConfiguration';
import { deletedUserConfigurationSessionSettingsProperties } from 'owa-service/lib/types/SessionUserConfiguration';
import type { OwaSessionStore } from '../store/schema/OwaSessionStore';
import { extractAccountScopeSettingsFromOwaUserConfiguration } from './extractAccountScopeSettingsFromOwaUserConfiguration';

export function convertOwaUserConfigurationToSessionStore(
    mailboxInfo: MailboxInfo,
    owaUserConfig: OwaUserConfiguration
): OwaSessionStore {
    // ATTENTION: This intentionally mutates the owaUserConfig object. In all likelihood you don't want to use
    // owaUserConfiguration after this. This is done to save an expensive OwaUserConfiguration copy while also
    // preventing extraneous non-type approprite properties being present on the observables.
    const accountSettings = extractAccountScopeSettingsFromOwaUserConfiguration(owaUserConfig);
    deletedUserConfigurationSessionSettingsProperties.forEach(key => {
        delete owaUserConfig.SessionSettings?.[key];
    });

    assert(!!mailboxInfo.sourceId);
    const sessionStore = {
        accountScopeUserSettingsMap: new ObservableMap({
            [mailboxInfo.sourceId]: accountSettings,
        }),
        userConfiguration: owaUserConfig as SessionUserConfiguration,

        defaultFolderIdToNameMap: accountSettings.defaultFolderIdToNameMap,
        connectedAccountsUserConfigurationMap: new ObservableMap({}),
    };

    return sessionStore;
}
